import HelixHelperText from '@components/helixHelperText';
import { FormControl, InputBaseProps, InputLabel, OutlinedInput, Stack, TextFieldProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import * as React from 'react';

type HelixInputProps = {
  placeholder: string;
  value?: string;
  variant: TextFieldProps['variant'];
  disabled?: boolean;
  color?: TextFieldProps['color'];
  helperText?: string;
  hasError?: boolean;
  label?: string;
  id?: string;
  startAdornment?: InputBaseProps['startAdornment'];
  endAdornment?: InputBaseProps['startAdornment'];
  multiline?: InputBaseProps['multiline'];
  onChange?: InputBaseProps['onChange'];
  maxLength?: number;
  minRows?: InputBaseProps['minRows'];
  type?: string;
  required?: boolean;
  autoComplete?: InputBaseProps['autoComplete'];
};

const HelixInput = React.forwardRef<HTMLInputElement, HelixInputProps>((innerProps, ref) => {
  const {
    placeholder,
    value,
    variant,
    disabled = false,
    color,
    helperText,
    hasError = false,
    label,
    id,
    startAdornment,
    endAdornment,
    multiline,
    onChange,
    maxLength,
    minRows,
    type,
    required,
    autoComplete,
  } = innerProps;

  const normalizedColor = hasError ? 'error' : color;

  const targetInput = (
    <HelixOutlinedInput
      id={id}
      name={id}
      placeholder={placeholder}
      size="small"
      value={value}
      disabled={disabled}
      error={hasError}
      multiline={multiline}
      startAdornment={startAdornment}
      endAdornment={endAdornment}
      onChange={onChange}
      minRows={minRows}
      type={type}
      required={required}
      autoComplete={autoComplete}
      ref={ref}
    />
  );

  return (
    <Stack spacing={1} alignItems="stretch">
      <InputLabel disabled={disabled} htmlFor={id}>
        {label}
      </InputLabel>
      <FormControl variant={variant} color={normalizedColor}>
        {targetInput}
        <HelixHelperText
          helperText={helperText}
          color={color}
          variant={variant}
          disabled={disabled}
          error={hasError}
          maxLength={maxLength}
          value={value}
        />
      </FormControl>
    </Stack>
  );
});

const HelixOutlinedInput = styled(OutlinedInput)(({ theme }) => {
  return {
    '& .MuiOutlinedInput-input': {
      padding: theme.spacing('12px', 2),
    },
    '& .MuiInputBase-inputAdornedStart': {
      paddingLeft: theme.spacing(1),
    },
  };
});

export { HelixInput as default, HelixInput };
export type { HelixInputProps };
